import script from "./rec-select.vue?vue&type=script&lang=ts&setup=true"
export * from "./rec-select.vue?vue&type=script&lang=ts&setup=true"

import "./rec-select.vue?vue&type=style&index=0&id=7d2f141a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d2f141a"]])

export default __exports__